// this is an autogenerated file from DesignSystem/TimelineEvent/Appointment/Actions/Scheduled/More/Cancel/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TimelineEvent_Appointment_Actions_Scheduled_More_Cancel_Content($id: uuid!) {
  vaxiom_appointment_booking_cancel(id: $id) {
    id
    appointment_booking {
      id
      _id
      state
      start_time
      end_time
      local_start_date
      local_start_time
      provider_id
      assistant_id
      chair_id
      appointment {
        id
        _id
        estimated_scheduling_date
      }
    }
  }
}

`